import o from "./ghl-ui.es816.js";
import t from "./ghl-ui.es817.js";
import a from "./ghl-ui.es818.js";
import r from "./ghl-ui.es819.js";
import m from "./ghl-ui.es820.js";
var e = {
  code: "nl",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = e;
export {
  s as default
};
